import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Tooltip,
  Select,
  Input,
  BackTop,
  Modal,
  Tag,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_tqa_work_b_list,
  req_downloadfile_tqa_worker,
} from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { getNowAcademicYear } from "../../utils/dateUtil";

import CollegeQuailtyB06 from "./college-quailty-b06";

class ManageWorkLevelBReport extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    academicYear: getNowAcademicYear(new Date()),
    isB01Modal: false,
    isB02Modal: false,
    isB03Modal: false,
    isB04Modal: false,
    isB05Modal: false,
    isTemplateModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      academicYear,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.api_page_run(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );
  };

  api_page_run = async (
    userCode,
    userLevel,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    academicYear,
    token
  ) => {
    this.setState({ loading: true });
    const result = await req_page_tqa_work_b_list(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus, academicYear } =
      this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_tqa_worker(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "品保手冊清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    const academicYear = getNowAcademicYear(new Date());
    this.setState({ academicYear });
    this.columns = [
      {
        title: "分類",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { WorkTypeCode } = item;
          return (
            <div className="text-center">
              <Tag color={this.style_switch_color_tag(WorkTypeCode)}>
                {this.style_switch_text_tag(WorkTypeCode)}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "單位",
        dataIndex: "DepartmentName",
        width: 40,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "負責老師",
        width: 30,
        responsive: ["md"],
        render: (item) => {
          const { AuthorName } = item;
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {AuthorName}</span>
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 70,
        render: (item) => {
          const { ReportTotal, WorkManualStatus } = item;
          return (
            <>
              {" "}
              <Tooltip title="當年度品保手冊文件">
                <button
                  type="button"
                  className={
                    ReportTotal === 0
                      ? "btn btn-outline-danger btn-sm"
                      : WorkManualStatus === "DONE"
                      ? "btn btn-outline-success btn-sm"
                      : "btn btn-outline-primary btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("Report", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {WorkManualStatus === "DONE" ? "檢視" : "上傳"}
                  </span>
                </button>
              </Tooltip>
            </>
          );
        },
      },
    ];
  };

  handle_show_ui_modal = (modal, item) => {
    //console.log("item", item);
    switch (modal) {
      case "Report":
        this.setState({ isReportModal: true, item });
        break;
      default:
    }
  };

  style_switch_text_tag(column) {
    let ans = "其他";
    switch (column) {
      case "A":
        ans = "學院"; // 學院
        break;
      case "B": // 中心
        ans = "中心";
        break;
      case "C":
        ans = "學系"; // 學系
        break;
      case "D":
        ans = "碩班"; //碩班
        break;
      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_color_tag(column) {
    let ans = "gold";
    switch (column) {
      case "A":
        ans = "#87d068"; // 學院
        break;
      case "B": // 中心
        ans = "#108ee9";
        break;
      case "C": // 學系
        ans = "magenta";
        break;
      case "D":
        ans = "#f50"; // 碩班
        break;
      default:
        ans = "gold";
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const value = e.target.value;
    const item = {
      activityNid: target_key,
      setPoints: value,
      condition: target_field,
    };
    //console.log(target_key)
    this.api_modify_item(item);
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      academicYear,
      isReportModal,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={academicYear}
          onChange={(event) =>
            this.setState({ academicYear: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="DepartmentName">單位</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
        <div style={{ float: "right" }}>
          <span style={{ fontSize: "8px" }}>按鈕顏色：</span>
          <Tag color="red">紅色：作業提醒</Tag>|{" "}
          <Tag color="gray">灰黑色：尚未作業</Tag>|{" "}
          <Tag color="blue">藍色：部分完成</Tag>|{" "}
          <Tag color="green">綠色：全數完成</Tag>
        </div>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="activityNid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isReportModal}
          width={"80%"}
          onOk={() => {
            this.setState({ isReportModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isReportModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <CollegeQuailtyB06 department={item} />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ManageWorkLevelBReport);
